"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Unauthorized = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const design_system_components_1 = require("@produits-internes-oss/design-system-components");
const octopod_auth_1 = require("@produits-internes-oss/octopod-auth");
const Unauthorized_styled_1 = require("./Unauthorized.styled");
const localization_1 = require("../../localization");
const illustration_svg_1 = __importDefault(require("../../assets/images/illustration.svg"));
const logo_svg_1 = __importDefault(require("../../assets/images/logo.svg"));
const Unauthorized = () => {
    const { login } = (0, octopod_auth_1.useAuthenticator)();
    return ((0, jsx_runtime_1.jsxs)(Unauthorized_styled_1.UnauthorizedStyled, { children: [(0, jsx_runtime_1.jsx)("img", { className: "logo", src: logo_svg_1.default, alt: "" }), (0, jsx_runtime_1.jsx)("img", { className: "illustration", src: illustration_svg_1.default, alt: "" }), (0, jsx_runtime_1.jsx)(design_system_components_1.Button, { className: "login", skin: "dark", kind: "primary", name: localization_1.localization.login.label, text: localization_1.localization.login.text, icon: { position: 'left', url: 'enter' }, onClick: () => login(process.env.OCTOPOD_HOST) })] }));
};
exports.Unauthorized = Unauthorized;
//# sourceMappingURL=Unauthorized.js.map